import {isBrowser} from "../../common/app/read_rp_environment_variables";
import {createRpStore, IRootState} from "../../common/store/store";

declare global {
    interface Window {
        __INITIAL_STATE__?: IRootState;
    }
}

let store: ReturnType<typeof createRpStore> | null = null;

if (isBrowser) {
    const initialState = window.__INITIAL_STATE__;
    delete window.__INITIAL_STATE__;

    store = createRpStore({
        preloadedState: initialState,
        ssrUtils: null
    });
} else {
    store = null;
}

export const getClientStore = () => store;
